import React from "react";
import { AiFillGithub, AiOutlineTwitter, AiFillInstagram, AiOutlineMail } from "react-icons/ai";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { Center, Flex, Text, VStack } from "@chakra-ui/react";

const Contact = () => {
  return (
    <div id="contact" style={{ height: "300px" }}>
      <Center>
        <Text fontSize="25px" mt="10px">
          FIND ME ON
        </Text>
      </Center>

      <Flex justify="center" mt="20px">
        <a id="contact-github" href="https://github.com/Kamalakanta01" style={{ margin: "0 10px" }}>
          <AiFillGithub size="2em" />
        </a>
        <a id="contact-linkedin" href="https://www.linkedin.com/in/kamalakanta-mahapatra-082825208/" style={{ margin: "0 10px" }}>
          <FaLinkedinIn size="2em" />
        </a>
        <a href="#" style={{ margin: "0 10px" }}>
          <AiFillInstagram size="2em" />
        </a>
      </Flex>

      <Center mt="20px">
        <VStack spacing="10px">
          <Flex alignItems="center">
            <BsFillTelephoneFill size="1.5em" />
            <Text id="contact-phone" ml="4px" color="#cd5ff8" textDecoration="underline">
              +91-9777846347
            </Text>
          </Flex>
          <Flex alignItems="center">
            <AiOutlineMail size="2em" />
            <Text id="contact-email" ml="4px" color="#cd5ff8" textDecoration="underline">
              mahapatrak898.kkm@gmail.com
            </Text>
          </Flex>
        </VStack>
      </Center>
    </div>
  );
};

export default Contact;